<script>

    import { createEventDispatcher } from 'svelte'
    import { toast } from 'bulma-toast'
    import { InvoiceStore } from '../stores'

    import InvoicesService from '../$services/invoices.service'
    import DateMethods from '../$methods/date.methods'
    import NumeralMethods from '../$methods/numeral.methods'

    import ButtonDelete from '../$components/button.delete.svelte'
    import Value from '../$components/value.svelte'

    const dispatch = createEventDispatcher()

    let loading = false
    let element = null

    async function getInvoiceDocument(type) {

        loading = true
        const blob = await InvoicesService.getInvoiceDocument($InvoiceStore.invoiceId, type)
        loading = false

        if(!blob)
            return toast({message: resp.error.message, type: 'is-danger'})

        element.download = `${$InvoiceStore.rfc}_${DateMethods.dateShort($InvoiceStore.created)}.${type}`
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }

    async function cancelInvoice() {

        loading = true
        const resp = await InvoicesService.cancelInvoice($InvoiceStore.invoiceId)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        InvoicesStore.remove($InvoiceStore._id)
        InvoiceStore.set(null)

        toast({message: 'Factura cancelada', type: 'is-success'})
        dispatch('deleted')
    }

</script>

{#if $InvoiceStore}
    <div class="columns">
        <div class="column">
            <Value label="RFC" value={ $InvoiceStore.rfc } />
        </div>
        <div class="column">
            <Value label="Monto" value={ NumeralMethods.cash($InvoiceStore.amount) } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="PDF" value="Descargar" icon="file-pdf" pointer on:click={() => getInvoiceDocument('pdf')} />
        </div>
        <div class="column">
            <Value label="XML" value="Descargar" icon="file-code" pointer on:click={() => getInvoiceDocument('xml')} />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Fecha de registro" value={ DateMethods.dateTimeLarge($InvoiceStore.created) } />
        </div>
    </div>
{/if}

<a href="/" bind:this={element} style="display: none;">#</a>